export const DESCRIPTION_MAX_LENGTH: number = 4000;
export const NAME_MAX_LENGTH: number = 300;
